<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
        <!-- p-0 h-100 overflow-y-hidden -->
        <!-- <img src="~/../assets/images/left-banner.jpg" style="height: 100%;" alt=""> -->
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15">
        <grid-row class="justify-content-center h-100">
            <grid-col col="4" mobile="12">
                <grid-row class="mt-mobile-15 justify-content-center h-100 pb-30">
                    <grid-col col="12">
                        <div class="font-400 font-size-24px line-h-32 color-base-700">
                            {{ "RelationshipCardHolder" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <div class="form-group mt-30">
                            <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedRelationship"
                                [dropDownData]="this.RelationshipList" (itemselected)="onRelationshipChange($event)">
                                {{this.selectedRelationship}}
                            </drop-down-list>
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <grid-row class="justify-content-between align-item-center mt-50">
                            <grid-col col="auto">
                                <div class="mt-15">
                                    <button class="btn-back" (click)="back()">
                                        <i class="icon-back"></i>
                                    </button>
                                </div>
                            </grid-col>
                            <grid-col col="9">
                                <button class="btn-dft" (click)="cardRequestVerifyYourself()">
                                    {{ "Next" | translate }}
                                </button>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </div>
</div>

<!-- Change Card -->
<modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="cancel" (doneButton)="AcceptLimit()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-card-limit" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"SetNewLimit" | translate}}
        </div>
        <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"AreSureWantIncrease" | translate}}
            </span>
            <strong class="color-base-700 line-h-25">
                {{"BHD" | translate}} 1000,000 ?
            </strong>
            <span class="font-400 line-h-25 color-base-500">
            </span>
        </div>
    </div>
</modal>